import React from 'react';
import { useTable, useSortBy, useFilters } from "react-table";
import Icon from '../ui/elements/Icon';
import Currency from '../ui/elements/Currency';



function Table({ columns, data }) {
  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    columns,
    data,
    defaultColumn,
    initialState: {
      sortBy: [
        {
          id: 'article',
          desc: false
        }
      ]
    }
  },
    useFilters,
    useSortBy
  );

  return (
    <table className="table is-bordered is-striped is-hoverable is-fullwidth is-narrow" {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, i) => (
              <th
                className="has-text-centered is-nowrapped" key={i}
              >
                <div key="0" {...column.getHeaderProps(column.getSortByToggleProps({ title: 'Сортировать' }))}>
                  {!column.disableSortBy ?
                    (<React.Fragment>
                      {column.render('Header')}{' '}<Icon icon={column.isSorted ? (column.isSortedDesc ? "caret-down" : "caret-up") : "sort"} />
                    </React.Fragment>)
                    :
                    column.render('Header')
                  } </div>
                <div style={{ marginTop: "5px" }} key="1">{column.canFilter ? column.render('Filter') : null}</div>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
              })}
            </tr>
          )
        })}
      </tbody>
      <tfoot>
        <tr>
          <td className="has-text-right is-size-2" colSpan="9">
            <Currency value={rows.reduce((a, b) => parseInt(a) + parseInt(b.values['sum']), 0)} />
          </td>
        </tr>
      </tfoot>
    </table>
  );
}

function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {

  return (
    <input
      className="input is-small"
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined)
      }}
      placeholder={`Поиск...`}
    />
  )
}

function NumberRangeColumnFilter({
  column: { filterValue = [], preFilteredRows, setFilter, id },
}) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
    preFilteredRows.forEach(row => {
      min = Math.min(row.values[id], min)
      max = Math.max(row.values[id], max)
    })
    return [min, max]
  }, [id, preFilteredRows])

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <input
        value={filterValue[0] || ''}
        className="input is-small"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
        }}
        placeholder={`${min}`}
        style={{
          width: '55px',
          marginRight: '0.3rem',
        }}
      />
      —
      <input
        value={filterValue[1] || ''}
        className="input is-small"
        onChange={e => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
        }}
        placeholder={`${max}`}
        style={{
          width: '55px',
          marginLeft: '0.3rem',
        }}
      />
    </div>
  )
}

class Shipment extends React.Component {
  constructor(props) {
    super(props);

    const sdata = [];
    this.props.parts.map((shipmentPart, i) =>
      sdata.push({
        brand: shipmentPart.part.brand.name,
        article: shipmentPart.part.article,
        description: shipmentPart.part.description,
        qty: shipmentPart.quantity,
        price: shipmentPart.price,
        sum: shipmentPart.sum
      })
    );


    this.state = {
      data: sdata
    }
  }

  render() {
    const columns = [
      {
        Header: 'Бренд',
        accessor: 'brand',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Артикул',
        accessor: 'article',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered"><a href={`/${this.props.employee ? 'office/' : ''}parts/search?query=${value}&mode=article`} target="_blank">
              {value}
            </a></p>
          );
        },
        sortType: 'basic'
      },
      {
        Header: 'Наименование детали',
        accessor: 'description',
      },
      {
        Header: 'Количество',
        accessor: 'qty',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ cell: { value } }) => {
          return (
            <p className="has-text-centered">
              {value}
            </p>
          );
        }
      },
      {
        Header: 'Цена',
        accessor: 'price',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-nowrapped has-text-right"><Currency value={Math.round(value)} /></p>
          );
        }
      },
      {
        Header: 'Сумма',
        accessor: 'sum',
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        Cell: ({ cell: { value } }) => {
          return (
            <p className="is-nowrapped has-text-right"><Currency value={Math.round(value)} /></p>
          );
        }
      }
    ];


    return (
      <div className="shipment_parts_table">
        <Table columns={columns} data={this.state.data} />
      </div>
    );
  }
}

Shipment.propTypes = {};

export default Shipment;